import reducers from './reducers';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { historyMiddleware } from './Middlewares/History.middleware';

global.ReduxServer = {
  createStore: (preloadState) => {
    global.LitiumReduxStore = createStore(
      reducers,
      preloadState,
      composeWithDevTools(applyMiddleware(thunk, historyMiddleware))
    );
  },
};
